export default function AppSection() {
  return (
    <section id="app" className="py-10 md:py-14 px-4 md:px-6 bg-background-100/60">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-6 lg:gap-10 p-6 md:p-8 rounded-2xl bg-background-50 border border-background-200/60">
          <div className="w-16 h-16 md:w-20 md:h-20 flex-shrink-0 rounded-2xl bg-primary-500 flex items-center justify-center">
            <i className="ri-smartphone-line text-2xl md:text-3xl text-background-50"></i>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-2">
              私密视频播放器移动端
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-2xl">
              支持手机浏览器直接访问，随时随地浏览香蕉视频、红桃视频、91视频、蜜桃视频等热门视频平台。无需下载 APP，打开浏览器输入网址即可畅享全部视频平台导航服务，兼容 iOS 与 Android 系统。
            </p>
          </div>
          <a
            href="#index"
            className="flex-shrink-0 inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-lg font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-right-line"></i>
            立即浏览
          </a>
        </div>
      </div>
    </section>
  );
}